// @flow
import { createSelector, type Selector } from 'reselect';
import { getOption, type Option } from '../form/select.js';

export const transactionsSelector: Selector<
  ReduxState,
  void,
  $ElementType<ReduxState, 'transactions'>
> = createSelector(
  state => state.transactions,
  transactions => transactions || {}
);

export const transactionsListSelector: Selector<ReduxState, void, List> = createSelector(
  state => state.transactionsList,
  transactionsSelector,
  (list, transactions) => (Array.isArray(list) ? [...list] : [])
        .filter(item => !!item)
        .sort((a, b) => transactions[a]?.createdTimestamp - transactions[b]?.createdTimestamp)
);

export const paymentTransactionsListSelector: Selector<
  ReduxState,
  void,
  $ElementType<ReduxState, 'transactions'>
> = createSelector(
  state => state.paymentTransactionsList,
  paymentTransactionsList => Array.isArray(paymentTransactionsList) ? paymentTransactionsList : []
);

export const creditsSelector: Selector<
  ReduxState,
  void,
  $ElementType<ReduxState, 'credits'>
> = createSelector(
  state => state.credits,
  credits => credits || {}
);

export const creditsListSelector: Selector<ReduxState, void, List> = createSelector(
  creditsSelector,
  credits => Object.keys(credits)
);

export const offlineTypeOptionsSelector: Selector<ReduxState, void, Option[]> = createSelector(
  state => state.offlineTypes,
  types =>
    Object.keys(types || {}).reduce(
      (acc, unique) => acc.concat(getOption(types[unique], unique, { type: 'type' })),
      []
    )
);
